<template>
  <div
    class="dialog-quill-edit"
    style="
       {
        'height':dialogvisible?'808px': 0;
      }
    "
  >
    <el-dialog
      :visible.sync="dialogVisible"
      width="968px"
      :before-close="handleClose"
      :show-close="false"
    >
      <div slot="title" class="title-warp">
        <div class="dialog-title-words">
          {{ dialogTitle }}
        </div>
        <i class="close-icon iconfont icon-guanbi" @click="closeDialog">
          <!-- <img class="close-img" src="../../assets/images/close.png" alt=""> -->
        </i>
      </div>
      <div>
        <VueQuillEdit
          :has-title="false"
          @getTextCount="getTextCount"
          :has-auth="false"
          v-model="editContent"
        />
      </div>

      <div slot="footer" class="footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="upData">上 传</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style lang="scss">
@import './index.scss';
</style>
<script>
import VueQuillEdit from '../vue-quill-edit/editor';
export default {
  name: 'DialogQuillEdit',
  components: {
    VueQuillEdit,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: true,
    },
    dialogTitle: {
      type: String,
      default: '编辑法律&隐私声明',
    },
    content: {
      type: String,
      default: '',
    },
    imageList: { type: Array, default: () => [] },
    videoList: { type: Array, default: () => [] },
    audioList: { type: Array, default: () => [] },
  },
  data() {
    return {
      editContent: '',
    };
  },
  watch: {
    // editContent(newval, oldval) {
    //   this.$emit("getContent", newval);
    // },

    content: {
      handler(newval) {
        this.editContent = newval.replace(/<img src="https:\/\/(?!eyao).*?>/g, ' ');
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.oldEditContent = this.content;
  },
  methods: {
    /**
     *管理弹窗
     */
    closeDialog() {
      this.editContent = this.content;
      this.$emit('closeDialog', false);
    },
    /**
     *点击上传
     */
    upData() {
      this.$emit('getContent', this.editContent);
      this.$emit('upData', false);
    },
    getTextCount(val) {
      this.$emit('getTextCount', val);
    },
    handleClose() {},
  },
};
</script>

<style lang="scss" scoped>
::v-deep.el-dialog__headerbtn {
  display: none;
}
.dialog-quill-edit {
  height: 808px;
  .el-dialog__header {
    color: #303133 100%;
    height: 53px;
    .title-warp {
      padding: 24px 20px 0;
      display: flex;
      justify-content: space-between;

      .close-icon {
        width: 24px;
        height: 24px;
        .close-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  ::v-deep.ql-toolbar.ql-snow {
    margin-bottom: 40px;
    // padding-bottom: 40px;
  }

  ::v-deep.ql-editor {
    padding-left: 40px;
    padding-right: 40px;
  }
  ::v-deep.ql-editor.ql-blank::before {
    left: 40px;
  }

  ::v-deep.quill-editor {
    background-color: rgba(245, 247, 250, 0.65);
  }

  ::v-deep#editor {
    min-width: 824px;
    min-height: 648px;
    margin-top: 0px;
    margin-bottom: 40px;
    margin-left: 40px;
    margin-right: 40px;
    // border-left: 40px solid rgba(245, 247, 250, 0.65);
    // border-right: 40px solid rgba(245, 247, 250, 0.65);
  }

  .footer {
    display: flex;
    justify-content: center;

    ::v-deep.el-button {
      width: 148px;
    }
  }
}
</style>
<style lang="scss" scoped>
@import './index.scss';
</style>
